export const DEFAULT_SCALARS = {
    ID: {
        input: 'string',
        output: 'string',
    },
    String: {
        input: 'string',
        output: 'string',
    },
    Boolean: {
        input: 'boolean',
        output: 'boolean',
    },
    Int: {
        input: 'number',
        output: 'number',
    },
    Float: {
        input: 'number',
        output: 'number',
    },
};
